import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, inject, ref } from 'vue';
import ExportCsv from '@/components/common/exportCsv/exportCsv.vue';
import { Builds_BuildsWhereInput, BuildsExportCsvDocument, BuildsExportCsvQuery, BuildsExportCsvQueryVariables, ExportCsv_Status } from '@/graphql/codegen/generated/graphql';
import { IKWorkloadsPageData } from '@/views/workloads/workloads.injectionKeys';
import { ExportOptions, ExportOptionsEnum, useExportCsvHelper } from '@/components/common/exportCsv/exportCsv.helpers';
import { useWorkloadsTableConstants } from '@/views/workloads/workloads.const';
import { useWorkloadsColumnsManagement } from '@/views/workloads/components/navbarComponents/manageColumns/manage-columns.helpers';
import { useOsService } from '@/services/OsService/OsService';
import { useWorkloadsTableUtils } from '@/views/workloads/workloads.utils';
import apolloClient from '@/plugins/GraphQL/Apollo/client';


export default /*#__PURE__*/_defineComponent({
  __name: 'exportBuildsCsvWrapper',
  setup(__props) {

const osService = useOsService();
const workloadsData = inject(IKWorkloadsPageData);
const tableData = useWorkloadsColumnsManagement();
const editTable = tableData?.tableEditor;
const workloadsTableConstants = useWorkloadsTableConstants();
const exportCSVModelValue = ref<ExportOptions>(null);
const { handleDynamicColumns } = useWorkloadsTableUtils();
const { isExportButtonDisabled, downloadCSVFile, handleDownloadCSVFileProcess, handleDownloadCSVFileOnResult, handleCSVFileName } = useExportCsvHelper();
const options = [ExportOptionsEnum.ExportView, ExportOptionsEnum.ExportAll];
const filePrefix = 'Builds';

const COLUMN_NAMES = Object.entries(workloadsTableConstants?.COLUMNS_NAMES[osService.osType.value]).reduce((acc, [key, value]) => {
  (acc as any)[value] = key;
  return acc;
}, {});

const prepareMapping = (mapObject: object) =>
  Object.entries(mapObject).map(([, value]) => ({
    field: (COLUMN_NAMES as any)[value.name],
    label: value.name,
  }));

const allColumnsViewMapping = computed(() => {
  const selectedColumns = editTable?.get[osService.osType.value].value.columnsOrder?.filter((column: any) => editTable?.get[osService.osType.value].value.columnsFilter[column.name]);
  const unSelectedColumns = editTable?.get[osService.osType.value].value.columnsOrder
    .filter((column: any) => !selectedColumns?.find((selectedColumn: any) => selectedColumn.name === column.name))
    .sort((a: any, b: any) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });

  return prepareMapping(handleDynamicColumns([...(selectedColumns || []), ...(unSelectedColumns || [])]));
});

const currentColumnsViewMapping = computed(() => {
  const columnsToMap = handleDynamicColumns(editTable?.get[osService.osType.value].value.columnsOrder).filter((column: any) => editTable?.get[osService.osType.value].value.columnsFilter[column.name]);
  return prepareMapping(columnsToMap) || [];
});

const handleDownloadBuildsCSV = async (downloadOption: ExportOptions) => {
  try {
    exportCSVModelValue.value = downloadOption;
    handleDownloadCSVFileProcess();
    const exportAllFilter = {
      ...workloadsData?.filter.getFilterDefaultValue(),
      timeframes: workloadsData?.filter.get.value.timeframes,
      sort: workloadsData?.filter.get.value.sort,
    } as Builds_BuildsWhereInput;

    const filter = exportCSVModelValue.value === ExportOptionsEnum.ExportView ? workloadsData?.filter.get.value : exportAllFilter;
    const GQL_buildFileId = await apolloClient.query<BuildsExportCsvQuery, BuildsExportCsvQueryVariables>({
      query: BuildsExportCsvDocument,
      variables: {
        filter: filter as Builds_BuildsWhereInput,
        fieldsMapping: exportCSVModelValue.value === ExportOptionsEnum.ExportView ? currentColumnsViewMapping.value : allColumnsViewMapping.value,
      },
      fetchPolicy: 'network-only',
    });

    handleDownloadCSVFileOnResult(GQL_buildFileId.data?.buildsExportCSV?.status as ExportCsv_Status);
    await downloadCSVFile(
      GQL_buildFileId.data?.buildsExportCSV?.fileId || '',
      handleCSVFileName(filePrefix, workloadsData?.filter.getTimeFrame.value.startTime, workloadsData?.filter.getTimeFrame.value.endTime),
    );
  } catch (error) {
    const code = (error as any).graphQLErrors[0].extensions.applicationErrorCode;
    handleDownloadCSVFileOnResult(ExportCsv_Status.Failure, code);
  }

  exportCSVModelValue.value = null;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ExportCsv, {
    "model-value": exportCSVModelValue.value,
    options: options,
    disabled: _unref(isExportButtonDisabled),
    "onUpdate:modelValue": handleDownloadBuildsCSV
  }, null, 8, ["model-value", "disabled"]))
}
}

})